module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Regular.4096ae7d.woff";